import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '@shopify/polaris';
/**
 * User-friendly error surface. Explains what happened and offers a retry,
 * per the UI error-state guidelines.
 */
export function ErrorState({ title = 'Something went wrong', message, onRetry, }) {
    return (_jsx(Banner, { tone: "critical", title: title, ...(onRetry ? { action: { content: 'Retry', onAction: onRetry } } : {}), children: _jsx("p", { children: message }) }));
}
//# sourceMappingURL=ErrorState.js.map